import {defineMessages} from 'react-intl';

export default defineMessages({
    title: {
        id: 'app.signup.expiredToken.title',
        defaultMessage: 'The link has expired.'
    },
    description: {
        id: 'app.signup.expiredToken.description',
        defaultMessage: 'For security reasons, the magic link is only valid for a couple of days. You can request a new email by clicking the button below.'
    },
    resendEmail: {
        id: 'app.signup.expiredToken.resendEmail',
        defaultMessage: 'Send new email'
    },
    emailSent: {
        id: 'app.signup.expiredToken.emailSent',
        defaultMessage: 'An email wth a new link has been sent to {email}'
    },
    sendEmailSuccess: {
        id: 'app.signup.expiredToken.sendEmailSuccess',
        defaultMessage: 'Signup email sent - Check your inbox!'
    },
    sendEmailError: {
        id: 'app.signup.expiredToken.sendEmailError',
        defaultMessage: 'An error occurred on the server'
    }
});
